import { InputAdornment } from "@material-ui/core";

export type { InputAdornmentProps } from "@material-ui/core";

export default InputAdornment;
